module.exports = __webpack_public_path__ + "static/media/login_logo_loisteyhtiot.f2244d2f.svg";